<template>
  <div class="editor-edit-lyrics">
    <div class="editor-edit-lyrics-open-state flex" @click="toggleOpenState">
      <div
        class="editor-edit-lyrics-open-state-switch flex pointer"
        :class="{
          active: renderData.isOpen,
        }"
      >
        <i class="block"></i>
      </div>
      <div class="editor-edit-lyrics-open-state-text width-0 flex1 olh">
        Edit selected lyrics
      </div>
    </div>
    <div
      class="editor-edit-lyrics-content"
      :class="{
        'editor-edit-lyrics-content-loading': props.loading,
      }"
    >
      <EditLyric
        :placeholder="props.placeholder"
        :maxLength="props.maxLength"
        :lyric="props.lyric"
        :type="props.type"
        :disabled="props.disabled"
        @change="onChange"
        :hasChange="props.hasChange"
        :getBeforeLyrics="props.getBeforeLyrics"
      ></EditLyric>

      <div class="editor-edit-lyrics-loading flex-center">
        <span class="block">
          {{ $$t("editor.audio_edit_data_processing_lyric") }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import { useRouter, useRoute } from "vue-router";

import EditLyric from "./editLyric.vue";

const Router = useRouter();
const route = useRoute();
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  maxLength: {
    type: Number,
    default: 500,
  },
  lyric: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: null,
  },
  placeholder: {
    type: String,
    default: null,
  },
  hasChange:{
    type: Boolean,
    default: false,
  },
  getBeforeLyrics:{
    type: Function,
    default: null
  }
});
const emits = defineEmits(["change"]);
const renderData = reactive({
  isOpen: false,
});

const toggleOpenState = () => {
  renderData.isOpen = !renderData.isOpen;
};

const onChange = (val, count) => {
  renderData.lyrics = val;
  renderData.lyricsCount = count;
  emits("change", val, count);
};

onMounted(() => {});

defineExpose({
  getLyrics: () => {
    return renderData.lyrics;
  },
});
</script>
<style lang="scss">
.editor-edit-lyrics {
  width: 100%;
  border-radius: 0 0 16px 16px;
  background: rgba(148, 173, 255, 0.2);
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: max-content;
  .editor-edit-lyrics-open-state {
    padding: 16px;
    align-items: center;
    display: none;
  }
  .editor-edit-lyrics-open-state-switch {
    width: 38px;
    height: 22px;
    border-radius: 40px;
    background: rgba(255, 255, 255, 0.2);
    justify-content: start;
    align-items: center;
    padding: 2px;
    i {
      width: 18px;
      height: 18px;
      border-radius: 40px;
      background: #ffffff;
    }
    &.active {
      justify-content: end;
      background: linear-gradient(
        120deg,
        rgba(201, 255, 240, 0.7) 0%,
        rgba(103, 231, 226, 0.8) 99%
      );
    }
  }
  .editor-edit-lyrics-open-state-text {
    font-family: HarmonyOS Sans SC;
    font-size: 15px;
    font-weight: normal;
    line-height: 24px;
    color: #ffffff;
    margin: 0 0 0 12px;
  }
  .editor-edit-lyrics-content {
    flex: 1;
    height: 0;
    position: relative;
    min-height: max-content;
    .editor-only-lyric {
      background: transparent;
      border-radius: 0 0 12px 12px;
    }
    .editor-edit-lyrics-loading {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 20px 20px 64px 20px;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.8);
      display: none;
    }

    &.editor-edit-lyrics-content-loading {
      .lyric-edit{
        visibility: hidden;
      }
      .editor-edit-lyrics-loading {
        display: flex;
      }
      .lyric-footer{
        opacity: 0.5;
        .count{
          opacity: 0.5;
        }
      }
    }
  }
}
</style>
